'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _partial = require('lodash/partial');

var _partial2 = _interopRequireDefault(_partial);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _fuse = require('fuse.js');

var _fuse2 = _interopRequireDefault(_fuse);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _highlightText = require('./highlight-text');

var _highlightText2 = _interopRequireDefault(_highlightText);

var _autocompleteLocal = require('./autocomplete.local.css');

var _autocompleteLocal2 = _interopRequireDefault(_autocompleteLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable no-return-assign, react/no-array-index-key */


var KC_TAB = 9;
var KC_ENTER = 13;
var KC_ESC = 27;
var KC_UP = 38;
var KC_DOWN = 40;

var AutoComplete = function (_Component) {
  _inherits(AutoComplete, _Component);

  function AutoComplete(props) {
    _classCallCheck(this, AutoComplete);

    var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));

    _initialiseProps.call(_this);

    var where = {};
    where[_this.props.valueKey] = _this.props.value;
    var selection = (0, _find3.default)(_this.props.options, where);
    _this.state = {
      dropdownIndex: 0,
      suggestions: [],
      selection: selection || null,
      searchQuery: _this.getDisplayValue(_this.props.value) || ''
    };
    _this.fuse = _this.createFuseObject(_this.props.options, _this.props.valueLabelKey);
    return _this;
  }

  _createClass(AutoComplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.makeCurrentSelection();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Reset lazily-loaded options property if options have changed
      if (!(0, _isEqual2.default)(this.props.options, nextProps.options)) {
        var newOptions = nextProps.options;
        this.setState({
          options: newOptions
        });
        this.fuse = this.createFuseObject(newOptions, nextProps.valueLabelKey);
      }

      if (this.props.value !== nextProps.value) {
        this.setState({
          searchQuery: nextProps.value
        });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var _state = this.state,
          selection = _state.selection,
          searchQuery = _state.searchQuery;
      var _props = this.props,
          valueLabelKey = _props.valueLabelKey,
          labelKey = _props.labelKey,
          suffixKey = _props.suffixKey;

      if (!selection) {
        return searchQuery;
      }

      var value = selection[valueLabelKey];

      if (labelKey) {
        value = selection[labelKey] + ': ' + value;
      }

      if (suffixKey) {
        value = '' + value + selection[suffixKey];
      }

      return value;
    }
  }, {
    key: 'getDisplayValue',
    value: function getDisplayValue(value) {
      if (value) {
        var selectedOption = (0, _find3.default)(this.props.options, _defineProperty({}, this.props.valueLabelKey, value));

        if (selectedOption) {
          return selectedOption.label;
        }
      }

      return value;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({
        searchQuery: '',
        selection: null,
        suggestions: [],
        dropdownIndex: 0
      });
    }
  }, {
    key: 'renderSuggestions',
    value: function renderSuggestions() {
      var _this2 = this;

      var _state2 = this.state,
          dropdownIndex = _state2.dropdownIndex,
          suggestions = _state2.suggestions,
          searchQuery = _state2.searchQuery;

      if (!suggestions) {
        return null;
      }

      return _react2.default.createElement('ul', {
        className: _autocompleteLocal2.default.list
      }, suggestions.map(function (suggestion, index) {
        return _react2.default.createElement('li', {
          className: (0, _classnames2.default)([_autocompleteLocal2.default.listItem, index === dropdownIndex && _autocompleteLocal2.default.listItemActive]),
          onMouseDown: (0, _partial2.default)(_this2.onSelection, suggestion),
          key: index
        }, _this2.props.labelKey && _react2.default.createElement('span', {
          className: _autocompleteLocal2.default.listItemLabel
        }, suggestion[_this2.props.labelKey]), _react2.default.createElement('span', {
          className: _autocompleteLocal2.default.listItemValue
        }, _react2.default.createElement(_highlightText2.default, {
          search: searchQuery
        }, suggestion[_this2.props.valueLabelKey])), _this2.props.suffixKey && _react2.default.createElement('span', {
          className: _autocompleteLocal2.default.listItemSuffix
        }, suggestion[_this2.props.suffixKey]));
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          placeholder = _props2.placeholder,
          id = _props2.id,
          className = _props2.className,
          dropdownHeight = _props2.dropdownHeight,
          inputClassName = _props2.inputClassName,
          disabled = _props2.disabled,
          theme = _props2.theme; // eslint-disable-line max-len

      var dropdownVisibleHeight = this.dropdownVisible() ? dropdownHeight : 0;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)([_autocompleteLocal2.default.component, className])
      }, _react2.default.createElement(_text2.default, {
        ref: function ref(el) {
          return _this3.input = el;
        },
        autoComplete: 'off',
        wrapperClassname: _autocompleteLocal2.default.inputWrapper,
        className: (0, _classnames2.default)([_autocompleteLocal2.default.input, inputClassName]),
        id: id,
        name: id,
        theme: theme,
        disabled: disabled,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        placeholder: placeholder,
        type: 'text',
        value: this.getValue()
      }), this.state.selection && _react2.default.createElement('button', {
        type: 'button',
        ref: function ref(el) {
          return _this3.clearButton = el;
        },
        className: _autocompleteLocal2.default.clearButton,
        onClick: this.handleClear
      }, 'Clear'), _react2.default.createElement('div', {
        ref: function ref(list) {
          _this3.suggestionList = list;
        },
        className: (0, _classnames2.default)([_autocompleteLocal2.default.dropDown, this.dropdownVisible() && _autocompleteLocal2.default.dropDownVisible]),
        style: dropdownVisibleHeight ? {
          maxHeight: dropdownVisibleHeight + 'px'
        } : null
      }, this.renderSuggestions()));
    }
  }]);

  return AutoComplete;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onSelection = function (selection) {
    _this4.setState({
      suggestions: [],
      selection: _this4.props.clearOnSelect ? null : selection,
      searchQuery: _this4.props.clearOnSelect ? '' : selection[_this4.props.valueLabelKey]
    }, function () {
      _this4.clearButton.focus();
    });

    if (_this4.props.onChange) {
      _this4.props.onChange(selection[_this4.props.valueKey]);
    }

    if (_this4.props.onSelection) {
      _this4.props.onSelection(selection);
    }
  };

  this.getSuggestions = function (query) {
    var suggestions = _this4.fuse.search(query);

    suggestions = suggestions.slice(0, _this4.props.maximumSuggestions);

    if (!suggestions) {
      suggestions = [];
    }

    return suggestions;
  };

  this.incrementAutoselect = function () {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var maxPosition = _this4.state.suggestions.length - 1;

    if (_this4.state.dropdownIndex < maxPosition) {
      _this4.updateDropdownScroll(Math.min(maxPosition, _this4.state.dropdownIndex + amount));
    }
  };

  this.decrementAutoselect = function () {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    if (_this4.state.dropdownIndex > 0) {
      _this4.updateDropdownScroll(Math.max(0, _this4.state.dropdownIndex - amount));
    }
  };

  this.updateDropdownScroll = function (newPosition) {
    _this4.setState({
      dropdownIndex: newPosition
    });

    _this4.adjustScrollPosition(newPosition);
  };

  this.adjustScrollPosition = function (dropdownIndex) {
    var selectedChild = _this4.suggestionList.children[0].children[dropdownIndex];
    var minScroll = selectedChild.offsetTop + selectedChild.offsetHeight - _this4.suggestionList.clientHeight;
    var maxScroll = selectedChild.offsetTop;

    if (_this4.suggestionList.scrollTop < minScroll) {
      _this4.suggestionList.scrollTop = minScroll;
    } else if (_this4.suggestionList.scrollTop > maxScroll) {
      _this4.suggestionList.scrollTop = maxScroll;
    }
  };

  this.makeCurrentSelection = function () {
    if (_this4.state.suggestions.length === 0) {
      return;
    }

    _this4.onSelection(_this4.state.suggestions[_this4.state.dropdownIndex]);
  };

  this.dropdownVisible = function () {
    return _this4.state.suggestions && _this4.state.suggestions.length > 0;
  };

  this.handleChange = function (_ref) {
    var value = _ref.target.value;
    var suggestions = void 0;
    var noPossibleMatches = void 0;
    var updatingLastQuery = void 0;

    if (value.length >= _this4.props.minimumCharacters) {
      updatingLastQuery = value.substring(0, value.length - 1) === _this4.state.searchQuery;
      noPossibleMatches = updatingLastQuery && value.length >= _this4.props.minimumCharacters + 5 && _this4.state.suggestions.length === 0;
      suggestions = noPossibleMatches ? [] : _this4.getSuggestions(value);
    } else {
      suggestions = [];
    }

    var newState = {
      searchQuery: value,
      selection: null,
      suggestions: suggestions
    };

    if (value === '' && _this4.props.showSuggestionsOnEmptyFocus) {
      newState.suggestions = _this4.props.options;
      newState.dropdownIndex = 0;
    }

    if (_this4.state.dropdownIndex >= newState.suggestions.length) {
      newState.dropdownIndex = newState.suggestions.length - 1;
    }

    _this4.setState(newState);

    if (_this4.props.onChange) {
      _this4.props.onChange(value);
    }
  };

  this.handleBlur = function (ev) {
    var newState = {};

    if (_this4.state.selection === null) {
      newState.suggestions = [];
    }

    if (_this4.props.retainValueOnBlur === false) {
      newState.searchQuery = '';
    }

    _this4.setState(newState);

    if (_this4.props.onBlur) {
      _this4.props.onBlur(ev);
    }
  };

  this.handleFocus = function (ev) {
    if (_this4.props.clearOnFocus && _this4.props.showSuggestionsOnEmptyFocus) {
      _this4.setState({
        searchQuery: '',
        selection: null,
        suggestions: _this4.props.options,
        dropdownIndex: 0
      });
    }

    if (_this4.state.selection) {
      ev.preventDefault();

      var selectionEnd = _this4.getValue().length;

      _this4.input.setSelection(0, selectionEnd);
    }

    if (_this4.props.onFocus) {
      _this4.props.onFocus(ev);
    }
  };

  this.handleClear = function (ev) {
    ev.preventDefault();

    _this4.setState({
      searchQuery: '',
      selection: null,
      suggestions: [],
      dropdownIndex: 0
    }, function () {
      _this4.input.setFocus();
    });

    if (_this4.props.onClearSelection) {
      _this4.props.onClearSelection();
    }
  };

  this.handleKeyDown = function (ev) {
    ev.stopPropagation();
    var code = ev.keyCode ? ev.keyCode : ev.which;

    switch (code) {
      case KC_UP:
        ev.preventDefault();

        _this4.decrementAutoselect();

        break;

      case KC_DOWN:
        ev.preventDefault();

        _this4.incrementAutoselect();

        break;

      case KC_ESC:
        _this4.setState({
          suggestions: [],
          selection: null
        });

        break;

      case KC_ENTER:
      case KC_TAB:
        if (_this4.dropdownVisible()) {
          if (code === KC_ENTER) {
            ev.preventDefault();
          }

          _this4.onSelection(_this4.state.suggestions[_this4.state.dropdownIndex]);
        }

        break;

      default:
        if (_this4.state.selection !== null) {
          ev.preventDefault();

          _this4.setState({
            searchQuery: ev.key.length === 1 ? ev.key : '',
            selection: null,
            suggestions: []
          });

          if (_this4.props.onClearSelection) {
            _this4.props.onClearSelection();
          }
        }

        break;
    }
  };

  this.createFuseObject = function (items, valueLabelKey) {
    return new _fuse2.default(items, {
      caseSensitive: false,
      includeScore: false,
      shouldSort: true,
      threshold: 0.1,
      tokenize: true,
      matchAllTokens: true,
      maxPatternLength: _this4.props.maximumCharacters,
      keys: [valueLabelKey]
    });
  };
};

AutoComplete.defaultProps = {
  className: null,
  clearOnFocus: false,
  clearOnSelect: false,
  dropdownHeight: null,
  inputClassName: null,
  valueLabelKey: 'label',
  maximumCharacters: 32,
  maximumSuggestions: 5,
  minimumCharacters: 3,
  labelKey: null,
  onChange: null,
  placeholder: '',
  retainValueOnBlur: false,
  showSuggestionsOnEmptyFocus: false,
  value: null,
  valueKey: 'value'
};
AutoComplete.propTypes = {
  /**
   * Define a custom className for the autocomplete container
   */
  className: _propTypes2.default.string,

  /**
   * Clears the current value when focused
   */
  clearOnFocus: _propTypes2.default.bool,

  /**
   * Clears the current value when a selection is made
   */
  clearOnSelect: _propTypes2.default.bool,

  /**
   * disable the input
   */
  disabled: _propTypes2.default.bool,

  /**
   * Height in px of dropdown
   */
  dropdownHeight: _propTypes2.default.number,

  /**
   * Classname for input component
   */
  inputClassName: _propTypes2.default.string,

  /**
   * Unique ID of input component
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  /**
   * Name of key that serves as the displayed value's label
   */
  labelKey: _propTypes2.default.string,

  /**
   * Name of key that serves as the displayed value's suffix
   */
  suffixKey: _propTypes2.default.string,

  /**
   * Callback when a selection is made
   */
  onSelection: _propTypes2.default.func.isRequired,

  /**
   * Maximum character input limit
   */
  maximumCharacters: _propTypes2.default.number,

  /**
   * Maximum amount of suggestions in view
   */
  maximumSuggestions: _propTypes2.default.number,

  /**
   * Minimum amount of characters before autocompletion
   */
  minimumCharacters: _propTypes2.default.number,

  /**
   * Callback function when input is blurred
   */
  onBlur: _propTypes2.default.func,

  /**
   * Callback function when input is changed
   */
  onChange: _propTypes2.default.func,

  /**
   * Callback function when input is focused
   */
  onFocus: _propTypes2.default.func,

  /**
   * Callback function for when value is reset
   */
  onClearSelection: _propTypes2.default.func,

  /**
   * Options to match on
   */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  })).isRequired,

  /**
   * Input placeholder
   */
  placeholder: _propTypes2.default.string,

  /**
   * Input retains value when input is blurred
   */
  retainValueOnBlur: _propTypes2.default.bool,

  /**
   * Show suggestions when user clicks on input
   */
  showSuggestionsOnEmptyFocus: _propTypes2.default.bool,

  /**
   * Sets the color theme to resemble a normal or classic input
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal']),

  /**
   * Name of key that represents the option value
   */
  valueKey: _propTypes2.default.string,

  /**
   * Name of the key that represents the option value label
   */
  valueLabelKey: _propTypes2.default.string,

  /**
   * value of the
   * @type {[type]}
   */
  value: _propTypes2.default.any
};
exports.default = AutoComplete;